module.exports = __webpack_public_path__ + "img/yangtao.3265ad8b.png";